module.exports = __webpack_public_path__ + "static/sledmax-bc2e8d677aae3f44801af19534543807.jpg";